import React, { useState } from 'react';
import emailjs from '@emailjs/browser';

const Contact = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    service: '',
    message: ''
  });
  const [errors, setErrors] = useState({});
  const [showSuccess, setShowSuccess] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);

  // Replace these with your EmailJS credentials
  const SERVICE_ID = 'service_r0vupk2';
  const TEMPLATE_ID = 'template_z3t380b';
  const PUBLIC_KEY = 'Wj8JQUQn1dM0l9IWf';

  const isValidEmail = (email) => {
    const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(String(email).toLowerCase());
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));

    // Clear error when user starts typing
    if (errors[name]) {
      setErrors(prev => ({
        ...prev,
        [name]: ''
      }));
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    // Basic form validation
    const newErrors = {};
    
    if (!formData.name.trim()) {
      newErrors.name = 'Please enter your name';
    }
    
    if (!isValidEmail(formData.email)) {
      newErrors.email = 'Please enter a valid email address';
    }
    
    if (!formData.message.trim()) {
      newErrors.message = 'Please enter a message';
    }
    
    setErrors(newErrors);
    
    // If form is valid, send email
    if (Object.keys(newErrors).length === 0) {
      setIsSubmitting(true);
      
      try {
        // EmailJS template variables
        const templateParams = {
          from_name: formData.name,
          from_email: formData.email,
          phone: formData.phone || 'Not provided',
          service: formData.service || 'Not specified',
          message: formData.message,
          to_email: 'info@thecleanknight.com'
        };

        await emailjs.send(
          SERVICE_ID,
          TEMPLATE_ID,
          templateParams,
          PUBLIC_KEY
        );

        // Show success message
        setShowSuccess(true);
        
        // Reset form
        setFormData({
          name: '',
          email: '',
          phone: '',
          service: '',
          message: ''
        });
        
        // Hide success message after 5 seconds
        setTimeout(() => {
          setShowSuccess(false);
        }, 5000);
        
      } catch (error) {
        console.error('Failed to send email:', error);
        alert('Sorry, there was an error sending your message. Please try again.');
      } finally {
        setIsSubmitting(false);
      }
    }
  };

  return (
    <section className="contact animate-on-scroll" id="contact">
      <div className="contact-info">
        <h2>Get in Touch</h2>
        <p>Ready to transform your home's exterior? Contact us today for a free quote or to learn more about our services.</p>
        <p><strong>Address:</strong> Unit 6B, Broadway Road, Windlesham, Surrey, GU18 6SU</p>
        <p><strong>Phone:</strong> 07721 617433</p>
        <p><strong>Email:</strong> info@thecleanknight.com</p>
        <p><strong>Hours:</strong> Monday - Friday: 8am - 6pm | Saturday: 9am - 3pm</p>
      </div>

      <div className="contact-form">
        {showSuccess && (
          <div className="success-message show">
            Thank you for your message! We will get back to you soon.
          </div>
        )}
        
        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label htmlFor="name">Name</label>
            <input
              type="text"
              id="name"
              name="name"
              className={`form-control ${errors.name ? 'error' : ''}`}
              value={formData.name}
              onChange={handleChange}
              required
              disabled={isSubmitting}
            />
            {errors.name && <div className="error-message show">{errors.name}</div>}
          </div>

          <div className="form-group">
            <label htmlFor="email">Email</label>
            <input
              type="email"
              id="email"
              name="email"
              className={`form-control ${errors.email ? 'error' : ''}`}
              value={formData.email}
              onChange={handleChange}
              required
              disabled={isSubmitting}
            />
            {errors.email && <div className="error-message show">{errors.email}</div>}
          </div>

          <div className="form-group">
            <label htmlFor="phone">Phone</label>
            <input
              type="tel"
              id="phone"
              name="phone"
              className="form-control"
              value={formData.phone}
              onChange={handleChange}
              disabled={isSubmitting}
            />
          </div>

          <div className="form-group">
            <label htmlFor="service">Service Interested In</label>
            <select
              id="service"
              name="service"
              className="form-control"
              value={formData.service}
              onChange={handleChange}
              disabled={isSubmitting}
            >
              <option value="">Select a service</option>
              <option value="driveway-washing">Driveway Washing</option>
              <option value="patio-cleaning">Patio Cleaning</option>
              <option value="gutter-cleaning">Gutter Cleaning</option>
              <option value="roof-cleaning">Roof Cleaning</option>
              <option value="solar-panel-cleaning">Solar Panel Cleaning</option>
              <option value="other">Other/Multiple Services</option>
            </select>
          </div>

          <div className="form-group">
            <label htmlFor="message">Message</label>
            <textarea
              id="message"
              name="message"
              className={`form-control ${errors.message ? 'error' : ''}`}
              value={formData.message}
              onChange={handleChange}
              required
              disabled={isSubmitting}
            ></textarea>
            {errors.message && <div className="error-message show">{errors.message}</div>}
          </div>

          <button type="submit" className="submit-btn" disabled={isSubmitting}>
            {isSubmitting ? 'Sending...' : 'Send Message'}
          </button>
        </form>
      </div>
    </section>
  );
};

export default Contact;